import { Message } from "../types";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/v1";

export const getMessageImage = (item: Pick<Message, "image">) => {
  const image = item.image;

  if (!image) {
    return "";
  }

  if (typeof image === "string") {
    if (
      image.startsWith("http://") ||
      image.startsWith("https://") ||
      image.startsWith("/")
    ) {
      return image;
    }

    return `${API_URL}/messages/public/image/${image}`;
  }

  if (image._id) {
    return `${API_URL}/messages/public/image/${image._id}`;
  }

  return "";
};

export const getMessageCta = (item?: Pick<Message, "cta"> | null) => {
  const label = item?.cta?.label?.trim() || "";
  const url = item?.cta?.url?.trim() || "";

  if (!label || !url) {
    return null;
  }

  return {
    label,
    url,
    type: item?.cta?.type === "external" ? "external" : "internal",
    openInNewTab: Boolean(item?.cta?.openInNewTab),
  };
};
